import React from 'react';
import { ArrowLeft, Settings } from 'lucide-react';

const Header = ({ 
  title, 
  subtitle, 
  showBack = false, 
  showSettings = false,
  onBack,
  onSettings,
  backgroundImage,
  className = ""
}) => {
  return (
    <div 
      className={`relative overflow-hidden rounded-b-3xl ${className}`}
      style={{
        backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      {/* Background overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-30"></div>
      
      {/* Content */}
      <div className="relative z-10 p-6">
        {/* Top bar with back button and settings */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center">
            {showBack && (
              <button
                onClick={onBack}
                className="p-2 text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-colors"
              >
                <ArrowLeft className="w-5 h-5" />
              </button>
            )}
          </div>
          
          {showSettings && (
            <button
              onClick={onSettings}
              className="p-2 text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-colors"
            >
              <Settings className="w-5 h-5" />
            </button>
          )}
        </div>

        {/* Title and subtitle */}
        <div className="text-center">
          <h1 className="text-2xl font-bold text-white mb-2">
            {title}
          </h1>
          {subtitle && (
            <p className="text-white text-opacity-90">
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
